import React from "react";
// If using react-router-dom for navigation:
// import { NavLink } from "react-router-dom";

// const navLinks = [
//   { to: "/", label: "Home" },
//   { to: "/art", label: "Art" },
//   { to: "/research", label: "Research" },
//   { to: "/blog", label: "Blog" },
//   { to: "/about", label: "About" },
//   { to: "/contact", label: "Contact" },
// ];

const Footer = () => (
  <footer
    style={{
      padding: "2em 0 1em 0",
      marginTop: "-0.5em",
      textAlign: "center",
      color: "#00000089",
      backgroundColor: "white",
    }}
  >
    {/* Logo on the left */}
    <h1 style={{ fontWeight: 'lighter', color: '#00000089' }}>
      Alacrity
    </h1>
    <div style={{ textAlign: "center", marginTop: "2.5em" }}>
      <a
        href="https://github.com/Daphiy"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="GitHub"
        className="footer-social-link"
      >
        <img
          src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/github.svg"
          alt="GitHub"
          className="footer-social-icon"
          style={{
            width: "32px",
            height: "32px",
            filter:
              "invert(13%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)",
          }}
        />
      </a>
      <a
        href="https://scholar.google.com/citations?user=R27JOScAAAAJ&hl=en&oi=ao"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Google Scholar"
        className="footer-social-link"
      >
        <img
          src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/googlescholar.svg"
          alt="Google Scholar"
          className="footer-social-icon"
          style={{
            width: "32px",
            height: "32px",
            filter:
              "invert(13%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)",
          }}
        />
      </a>
      <a
        href="https://www.linkedin.com/in/daphna-keidar-3197a1128/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="LinkedIn"
        className="footer-social-link"
      >
        <img
          src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/linkedin.svg"
          alt="LinkedIn"
          className="footer-social-icon"
          style={{
            width: "32px",
            height: "32px",
            filter:
              "invert(13%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)",
          }}
        />
      </a>
    </div>
    <div
      style={{
        fontSize: "0.95em",
        color: "#000000ff",
        marginTop: "1em",
        padding: "1em 0",
      }}
    >
      &copy; 2025 Daphna Keidar. All rights reserved.
    </div>
  </footer>
);

export default Footer;